









































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { documentNumberApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";
import { NumberSequence as INumberSequence } from "@/api-v2/document-number/models/number-sequence";
import DocumentNumberForm from "@/components/document-number/DocumentNumberForm.vue";
import { sprintf } from "@/utils/sprintf";
import { isRoot, currentUserIsCompanyOwner } from "@/plugins/roles";
import DocumentNumberItem from "@/components/document-number/DocumentNumberItem.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import list, {
  DocumentNumberingListParams
} from "@/getinfo-api/document-numbering";

@Component({
  components: {
    CustomTable,
    DocumentNumberItem,
    CField,
    CBlock,
    CPage,
    DocumentNumberForm
  }
})
export default class DocumentNumberList extends Vue {
  items: Array<INumberSequence> = [];
  count: number = 0;
  limit: number = 30;
  offset: number = 0;
  isShowSpinner: boolean = false;

  get companyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get isCompanyOwner() {
    return currentUserIsCompanyOwner();
  }

  formatted(value: string, index: any): any {
    return sprintf(value, index);
  }

  addSequenceToList(item: INumberSequence) {
    this.$store.dispatch("successToast", {
      message: `${this.$tc(this.$translate.Successful)}`
    });
    this.items = [item, ...this.items];
  }

  sequenceEdit(item: INumberSequence) {
    this.$store.dispatch("successToast", {
      message: `${this.$tc(this.$translate.Successful)}`
    });
    const index = this.items.findIndex(el => el.id === item.id);

    this.items.splice(index, 1, item);
  }

  async sequenceDelete(item: INumberSequence) {
    try {
      await documentNumberApi.deleteSequence(this.companyId, item.id);
      const index = this.items.findIndex(el => el.id === item.id);
      this.items.splice(index, 1);
    } catch (e) {
      throw new Error(e as any);
    }
  }

  async getSequences() {
    try {
      this.isShowSpinner = true;
      const params: DocumentNumberingListParams = {
        companyId: this.companyId,
        limit: 100,
        order: "DESC",
        sort: "title"
      };
      const { data } = await list(params);
      this.items = data;
    } finally {
      this.isShowSpinner = false;
    }
  }

  created() {
    this.getSequences();
  }
}
